module.exports = __webpack_public_path__ + "images/Doctors_Healthcare_watermark_06f5c54.png";